// extracted by mini-css-extract-plugin
export default {"AccordionItem":"AccordionItem_AccordionItem__ZTAxY"};